import { TComplimentaryProductInfo, TCalculateData } from 'pages/dimensions/store/dimensions';

type TGetNewCountValue = {
  prevState: TCalculateData;
  newValue: number;
  product: TComplimentaryProductInfo;
};

export const addNewCountValue = ({ prevState, newValue, product }: TGetNewCountValue) =>
  prevState.complimentaryProductInfo.map(item =>
    item.productId === product.productId
      ? {
          ...product,
          total: {
            ...item.total,
            requiredQuantity: newValue,
          },
        }
      : item
  );
